module.exports = __webpack_public_path__ + "img/img_john.a2089963.png";